/* eslint-disable */
import * as React from 'react';
import makeStyles from "@material-ui/styles/makeStyles";

const useClasses = makeStyles(theme => ({
  reportToolbarNumber: {
    padding: '4px 24px 4px 4px',
    color: "#000",
    fontWeight: 'bold',
    fontSize: '14px',
  }
}));

export type ReportToolbarNumberProps = { number: number };

export const ReportToolbarNumber: React.FC<ReportToolbarNumberProps> = ({ number }) => {
  const classes = useClasses();
  const component = React.useMemo(() => {
    return <span className={classes.reportToolbarNumber}>AP Agriculture Terminal: Report {number}</span>
  }, [number]);
  return component;
}